import { ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import React from 'react';

import { SearchCarousel } from '@shared-ui/retail-lodging-search-carousel';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { UitkSpacing } from 'uitk-react-spacing';

interface CarouselSearchWrapperInterface {
  searchResults: SearchResultsStore;
  context: ContextStore;
}

export const CarouselSearchWrapper = inject(
  'searchResults',
  'context'
)(({ searchResults, context }: CarouselSearchWrapperInterface) => (
  <UitkSpacing margin={{ blockend: 'twelve' }} padding={{ blockend: 'twelve' }}>
    <div>
      <SearchCarousel inputs={{ criteria: adaptSearchCriteria(context, searchResults.searchCriteria, false) }} />
    </div>
  </UitkSpacing>
));
